import uuid from 'uuid-random';

export const PageNotFoundError = class extends Error {
    constructor(error) {
        super();

        this.message = error;
    }
};

export const PageForbiddenError = class extends Error {
    constructor(permissions) {
        super();

        this.permissions = permissions;
    }
};

export const onResponse = (data, path, role, isAdmin) => {
    if (!data.success) {
        throw new PageNotFoundError(data.error);
    }

    if (!isAdmin && !data.permissions[role]) {
        throw new PageForbiddenError(data.permissions);
    }

    if (data.portlets) {
        data.portlets = data.portlets.map(portlet => ({
            ...portlet,
            reactPortletId: portlet.portletId,
            portletKey: uuid()
        }));
    } else {
        data.portlets = [];
    }

    return { path, ...data };
};

export const onError = (error, path) => ({
    path,
    error,
    is404Error: error instanceof PageNotFoundError || error.status === 404,
    is403Error: error instanceof PageForbiddenError
});
